import { render, staticRenderFns } from "./AppLoadingBar.vue?vue&type=template&id=605f1b08&scoped=true&"
import script from "./AppLoadingBar.vue?vue&type=script&lang=ts&"
export * from "./AppLoadingBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoadingBar.vue?vue&type=style&index=0&id=605f1b08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f1b08",
  null
  
)

export default component.exports